<app-shopping-cart></app-shopping-cart>
<div class="workspace bg-radial">
  <top-bar [titleTranslationCode]="'NAVIGATION.COURSES'"
           [redirectLink]="'../../'"
           [defaultRedirectTranslationCodes]="true"
  >
    <footer>
      <div class="row d-none d-md-flex">
        <div class="col-10">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" aria-current="page">
                <a class="pe-none">
                  {{ "NAVIGATION.COURSES" | translate }}
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ CourseFilterComponent.getLanguageTranslation(chosenCourse) | translate }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </footer>
  </top-bar>
  <div class="container mt-md-3">
    <app-course-filter (languageEmitter)="chosenCourse = $event"></app-course-filter>
    <div class="row position-relative pb-3">
      <spinner class="w-100 spinner"></spinner>
    </div>
    <section *ngIf="chosenCourse?.filter == 'en' || chosenCourse?.filter == ''">
      <app-course-card
        [langCode]="'en'"
        [isSupported]="isLangSupported('en')"
      ></app-course-card>
      <app-english-course></app-english-course>
    </section>
    <section *ngIf="chosenCourse.filter == 'sp' || chosenCourse.filter == ''">
      <app-course-card
        [langCode]="'sp'"
        [isSupported]="isLangSupported('sp')"
      ></app-course-card>
      <app-spanish-course></app-spanish-course>
    </section>
    <section *ngIf="chosenCourse.filter == 'en.bs' || chosenCourse.filter == ''">
      <app-course-card
        [langCode]="'en.bs'"
        [isSupported]="isLangSupported('en.bs')"
      ></app-course-card>
      <app-english-business-course></app-english-business-course>
    </section>
    <section *ngIf="chosenCourse.filter == 'en.ch' || chosenCourse.filter == ''">
      <app-course-card
        [langCode]="'en.ch'"
        [isSupported]="isLangSupported('en.ch')"
      ></app-course-card>
      <app-kids-course></app-kids-course>
    </section>
  </div>
</div>
